module.exports = __webpack_public_path__ + "static/media/bedCorrect.384e12f5.png";